<template>
  <v-text-field
    v-bind="$attrs"
    :class="`${textAlign}-input`"
    :model-value="internalValue"
    @focus="focus"
    @update:model-value="internalValue = $event"
    @update:focused="$event ? null : (model = parse(internalValue))"
  />
</template>

<script lang="ts" setup>
import { app } from "@/main";
import { computed, ref, watch } from "vue";

const $format = app.config.globalProperties.$format;

const props = withDefaults(
  defineProps<{
    modelValue?: number;
    required?: boolean;
    textAlign?: "left" | "right";
  }>(),
  {
    textAlign: "right",
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", item: number | null): void;
}>();

const internalValue = ref<string>("");

const model = computed({
  get: () => props.modelValue,
  set: (value: number | null) => {
    if (props.required && value === null) {
      value = 0;
    }
    internalValue.value = $format.decimal(value);
    emit("update:modelValue", value);
  },
});

watch(
  model,
  () => {
    internalValue.value =
      model.value !== null ? $format.decimal(model.value) : "";
  },
  { immediate: true }
);

if (props.required && props.modelValue === null) {
  model.value = 0;
}
const focus = (event: Event) => {
  const target = event.target as HTMLInputElement;
  target.select();
};

const parse = (val: string) => {
  val = val.replaceAll(",", "").replaceAll(" ", "");
  const num = parseFloat(val);
  if (isNaN(num)) return null;
  return num;
};
</script>
